/* Mobile product sheets share the approved desktop hotspot catalogue. */
if (!customElements.get('mgp-mobile-hero')) {
  customElements.define('mgp-mobile-hero', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-mgp-mobile-hero]');
      if (!this.root) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.mobile = matchMedia('(max-width:640px)');
      this.root.addEventListener('click', event => {
        const trigger = event.target.closest('[data-hero-products-open]');
        if (trigger && this.mobile.matches) {
          const dialog = document.getElementById(trigger.dataset.heroProductsOpen);
          if (!dialog || !this.contains(dialog)) return;
          this.opener = trigger;
          this.dialog = dialog;
          dialog.showModal();
          document.documentElement.classList.add('mgp-hero-modal-open');
          this.notify();
        }
        if (event.target.closest('[data-hero-products-close]')) this.dialog?.close();
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('mgp-hero-modal-open');
          this.dialog = null;
          this.opener?.focus({preventScroll:true});
          this.notify();
        }, options);
      });
      this.mobile.addEventListener('change', () => this.dialog?.close(), options);
      this.root.addEventListener('keydown', event => {
        if (!event.target.matches('.flickity-page-dots .dot')) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.target.click();
        }
      }, options);
      this.observer = new MutationObserver(() => this.labelDots());
      this.observer.observe(this.root, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] });
      this.labelDots();
    }
    labelDots() {
      const slides = [...this.root.querySelectorAll('.slideshow__slide')];
      // Off-screen slides must not receive focus and scroll the hidden viewport.
      slides.forEach(slide => { slide.inert = !slide.classList.contains('is-selected'); });
      this.root.querySelectorAll('.flickity-page-dots .dot').forEach((dot, index) => {
        dot.setAttribute('role', 'button');
        dot.tabIndex = 0;
        const title = slides[index]?.querySelector('.slideshow__title')?.textContent.trim();
        if (title) dot.setAttribute('aria-label', title);
        dot.setAttribute('aria-current', String(dot.classList.contains('is-selected')));
      });
    }
    notify() { this.dispatchEvent(new CustomEvent('mgp:hero-card', {bubbles:true})); }
    disconnectedCallback() {
      this.dialog?.close();
      this.observer?.disconnect();
      this.abort?.abort();
      document.documentElement.classList.remove('mgp-hero-modal-open');
    }
  });
}

